"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.foxyStakingAbi = void 0;
exports.foxyStakingAbi = [
    {
        inputs: [
            {
                internalType: 'address',
                name: '_stakingToken',
                type: 'address'
            },
            {
                internalType: 'address',
                name: '_rewardToken',
                type: 'address'
            },
            {
                internalType: 'address',
                name: '_tokeToken',
                type: 'address'
            },
            {
                internalType: 'address',
                name: '_tokePool',
                type: 'address'
            },
            {
                internalType: 'address',
                name: '_tokeManager',
                type: 'address'
            },
            {
                internalType: 'address',
                name: '_tokeReward',
                type: 'address'
            },
            {
                internalType: 'address',
                name: '_liquidityReserve',
                type: 'address'
            },
            {
                internalType: 'uint256',
                name: '_epochLength',
                type: 'uint256'
            },
            {
                internalType: 'uint256',
                name: '_firstEpochNumber',
                type: 'uint256'
            },
            {
                internalType: 'uint256',
                name: '_firstEpochBlock',
                type: 'uint256'
            }
        ],
        stateMutability: 'nonpayable',
        type: 'constructor'
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'previousOwner',
                type: 'address'
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address'
            }
        ],
        name: 'OwnershipPulled',
        type: 'event'
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'previousOwner',
                type: 'address'
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address'
            }
        ],
        name: 'OwnershipPushed',
        type: 'event'
    },
    {
        inputs: [],
        name: 'COOL_DOWN_CONTRACT',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [],
        name: 'LIQUIDITY_RESERVE',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [],
        name: 'REWARD_TOKEN',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [],
        name: 'STAKING_TOKEN',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [],
        name: 'TOKE_MANAGER',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [],
        name: 'TOKE_POOL',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [],
        name: 'TOKE_REWARD',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [],
        name: 'TOKE_TOKEN',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [],
        name: 'WARM_UP_CONTRACT',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_amount',
                type: 'uint256'
            },
            {
                internalType: 'bool',
                name: '_trigger',
                type: 'bool'
            }
        ],
        name: 'addRewardsForStakers',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_recipient',
                type: 'address'
            }
        ],
        name: 'claim',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: 'uint256',
                        name: 'chainId',
                        type: 'uint256'
                    },
                    {
                        internalType: 'uint256',
                        name: 'cycle',
                        type: 'uint256'
                    },
                    {
                        internalType: 'address',
                        name: 'wallet',
                        type: 'address'
                    },
                    {
                        internalType: 'uint256',
                        name: 'amount',
                        type: 'uint256'
                    }
                ],
                internalType: 'struct Recipient',
                name: '_recipient',
                type: 'tuple'
            },
            {
                internalType: 'uint8',
                name: '_v',
                type: 'uint8'
            },
            {
                internalType: 'bytes32',
                name: '_r',
                type: 'bytes32'
            },
            {
                internalType: 'bytes32',
                name: '_s',
                type: 'bytes32'
            }
        ],
        name: 'claimFromTokemak',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_recipient',
                type: 'address'
            }
        ],
        name: 'claimWithdraw',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address'
            }
        ],
        name: 'coolDownInfo',
        outputs: [
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256'
            },
            {
                internalType: 'uint256',
                name: 'gons',
                type: 'uint256'
            },
            {
                internalType: 'uint256',
                name: 'expiry',
                type: 'uint256'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [],
        name: 'coolDownPeriod',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [],
        name: 'epoch',
        outputs: [
            {
                internalType: 'uint256',
                name: 'length',
                type: 'uint256'
            },
            {
                internalType: 'uint256',
                name: 'number',
                type: 'uint256'
            },
            {
                internalType: 'uint256',
                name: 'endBlock',
                type: 'uint256'
            },
            {
                internalType: 'uint256',
                name: 'distribute',
                type: 'uint256'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [],
        name: 'getNewOwner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [],
        name: 'getOwner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'bool',
                name: '_trigger',
                type: 'bool'
            }
        ],
        name: 'instantUnstake',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [],
        name: 'lastTokeCycleIndex',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [],
        name: 'pauseStaking',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [],
        name: 'pauseUnstaking',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [],
        name: 'pullOwner',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_newOwner',
                type: 'address'
            }
        ],
        name: 'pushOwner',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [],
        name: 'rebase',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [],
        name: 'requestWithdrawalAmount',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [],
        name: 'sendWithdrawalRequests',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_vestingPeriod',
                type: 'uint256'
            }
        ],
        name: 'setCoolDownPeriod',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'length',
                type: 'uint256'
            }
        ],
        name: 'setEpochLength',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_timestamp',
                type: 'uint256'
            }
        ],
        name: 'setTimeLeftToRequestWithdrawal',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_vestingPeriod',
                type: 'uint256'
            }
        ],
        name: 'setWarmUpPeriod',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'bool',
                name: '_shouldPause',
                type: 'bool'
            }
        ],
        name: 'shouldPauseStaking',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'bool',
                name: '_shouldPause',
                type: 'bool'
            }
        ],
        name: 'shouldPauseUnstaking',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_amount',
                type: 'uint256'
            },
            {
                internalType: 'address',
                name: '_recipient',
                type: 'address'
            }
        ],
        name: 'stake',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_amount',
                type: 'uint256'
            }
        ],
        name: 'stake',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [],
        name: 'timeLeftToRequestWithdrawal',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_claimAddress',
                type: 'address'
            }
        ],
        name: 'transferToke',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_amount',
                type: 'uint256'
            },
            {
                internalType: 'bool',
                name: '_trigger',
                type: 'bool'
            }
        ],
        name: 'unstake',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [],
        name: 'unstakeAllFromTokemak',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address'
            }
        ],
        name: 'warmUpInfo',
        outputs: [
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256'
            },
            {
                internalType: 'uint256',
                name: 'gons',
                type: 'uint256'
            },
            {
                internalType: 'uint256',
                name: 'expiry',
                type: 'uint256'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [],
        name: 'warmUpPeriod',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [],
        name: 'withdrawalAmount',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    }
];
